import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const INPUT_OCCUPATION_REQUEST = 'sherrinford/occupation/add/INPUT_OCCUPATION_REQUEST'
export const INPUT_OCCUPATION_SUCCESS = 'sherrinford/occupation/add/INPUT_OCCUPATION_SUCCESS'
export const INPUT_OCCUPATION_ERROR = 'sherrinford/occupation/add/INPUT_OCCUPATION_ERROR'

export const IS_LOADING = 'sherrinford/occupation/add/IS_LOADING'
export const DATA = 'sherrinford/occupation/add/DATA'

export const SET_ADD_NEW_OCCUPATION = 'sherrinford/occupation/add/SET_ADD_NEW_OCCUPATION'

const initialState = {
  data: {
    name: '',
    status: 2,
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
  isAddNewOccupation: false,
}

export default createReducer(initialState, {
  [INPUT_OCCUPATION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [INPUT_OCCUPATION_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [INPUT_OCCUPATION_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, occupation) => {
    const { data } = occupation
    return {
      ...state,
      data,
    }
  },

  [SET_ADD_NEW_OCCUPATION]: (state, data) => ({
    ...state,
    isAddNewOccupation: data,
  }),
})

export const setOccupation = (data, cb) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      INPUT_OCCUPATION_REQUEST,
      INPUT_OCCUPATION_SUCCESS,
      INPUT_OCCUPATION_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/occupation',
      payloads: data,
      authorization: `${token}`,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setAddNewOccupation = data => ({
  type: [SET_ADD_NEW_OCCUPATION],
  payload: data,
})
